import { useEffect, useRef, useState } from "react";
import ClientInformation from "../ClientInformation";
import EchoTable from "../EchoTable";

const Echocardiography = () => {
  const [value, setValue] = useState(
    `B- mode: normal cardiac chamber. Normal pericardial sac.
    
Left ventricle study:
 `,
  );
  const [value2, setValue2] = useState(
    `Left atrium and aorta:  

Mitral valve study: 

Pulse Wave Doppler

Aortic valve-             LVOT Vmax   — 

Pulmonary valve-     RVOT Vmax  —

Color Doppler:

                 MV,TV, AoV, PV - Normal color flow. 

Comments: 

NAD

INTERPRETATION/COMMENTS:

 `,
  );

  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const textareaRef2 = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    adjustHeight();
  }, [value]);

  useEffect(() => {
    adjustHeight2();
  }, [value2]);

  const adjustHeight = () => {
    if (textareaRef.current) {
      const element = textareaRef.current;
      const newHeight = element.scrollHeight;

      // Only update if the height actually needs to change
      if (element.style.height !== `${newHeight}px`) {
        element.style.height = "auto"; // Reset first
        element.style.height = `${newHeight}px`; // Then set new height
      }
    }
  };
  const adjustHeight2 = () => {
    if (textareaRef2.current) {
      const element = textareaRef2.current;
      const newHeight = element.scrollHeight;

      // Only update if the height actually needs to change
      if (element.style.height !== `${newHeight}px`) {
        element.style.height = "auto"; // Reset first
        element.style.height = `${newHeight}px`; // Then set new height
      }
    }
  };

  return (
    <div>
      <ClientInformation />
      <p className="text-center font-bold inline-block border-b-2 border-gray-500 ">FINDINGS :</p>

      <div className="flex  gap-2 print:gap-1 w-full  print:-mb-2  mb-2">
        <textarea
          ref={textareaRef}
          className="w-full border p-4 text-sm resize-none print:hidden"
          value={value}
          autoFocus
          onInput={adjustHeight} // Adjusts height on input instead of useEffect
          onChange={(e) => setValue(e.target.value)}
          style={{ overflowY: "auto", scrollbarWidth: "thin", fontSize: "14px" }}
        />
        <div className="hidden print:block w-full print:border-none p-2 text-sm whitespace-pre-wrap">{value}</div>
      </div>
      <EchoTable />

      <div className="flex  gap-2 print:gap-1 w-full  print:-mb-2  mb-2">
        <textarea
          ref={textareaRef2}
          className="w-full border p-4 text-sm resize-none print:hidden"
          value={value2}
          autoFocus
          onInput={adjustHeight} // Adjusts height on input instead of useEffect
          onChange={(e) => setValue2(e.target.value)}
          style={{ overflowY: "auto", scrollbarWidth: "thin", fontSize: "14px" }}
        />
        <div className="hidden print:block w-full print:border-none p-2 text-sm whitespace-pre-wrap">{value2}</div>
      </div>
      <div className="flex items-center gap-2 ">
        <p className="text-sm">Doctor's Name:</p>
        <input type="text" className="text-sm w-[400px] border p-1" />
      </div>

      <p className="font-bold mt-3 italic">This report is not valid for Vetero-Legal Purposes</p>
    </div>
  );
};
export default Echocardiography;
